export default {
    section: 'Seller Information',
    name: 'offer-letter-seller',
    items: [
        {
            type: 'inline',
            text: 'Seller Name',
            items: [
                {
                    type: 'text-field',
                    name: 'offer-letter-seller-first-name',
                    width: 3,
                    props: {
                        label: 'First Name'
                    }
                },
                {
                    type: 'text-field',
                    name: 'offer-letter-seller-last-name',
                    width: 3,
                    props: {
                        label: 'Last Name'
                    }
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Seller Address',
            name: 'offer-letter-seller-address-street',
            props: {
                label: 'Address'
            },
            subItems: [
                {
                    type: 'inline',
                    text: ' ',
                    items: [
                        {
                            type: 'text-field',
                            name: 'offer-letter-seller-address-city',
                            width: 3,
                            props: {
                                label: 'City'
                            }
                        },
                        {
                            type: 'selectlist',
                            name: 'offer-letter-seller-address-state',
                            width: 1,
                            props: {
                                label: 'State',
                                items: [
                                    // TODO: Swap States
                                    {
                                        text: 'swap-states',
                                        value: 'swap-states'
                                    }
                                ]
                            }
                        },
                        {
                            type: 'text-field',
                            name: 'offer-letter-seller-address-zip',
                            width: 2,
                            props: {
                                label: 'Zip'
                            }
                        }
                    ]
                }
            ]
        },
        {
            type: 'text-field',
            text: 'Formal Company Name',
            name: 'offer-letter-seller-company-name',
            props: {
                label: 'Formal Company Name'
            }
        },
        {
            type: 'selectlist',
            text: 'Entity Type',
            name: 'offer-letter-seller-entity-type',
            width: 3,
            props: {
                items: [
                    {
                        text: 'swap-entity-types',
                        value: 'swap-entity-types'
                    }
                ]
            }
        },
        {
            type: 'checkbox-list',
            text: 'Selling as:',
            name: 'offer-letter-seller-selling-as',
            props: {
                items: [
                    {
                        text: 'Individual',
                        value: 'individual'
                    },
                    {
                        text: 'Company',
                        value: 'company'
                    }
                ]
            }
        },
        {
            type: 'radio-list',
            text: 'Selling:',
            name: 'offer-letter-seller-selling',
            props: {
                items: [
                    {
                        text: 'Partial Book Sale',
                        value: 'partial-sale'
                    },
                    {
                        text: 'Full Sale',
                        value: 'full-sale'
                    }
                ]
            }
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/seller-information.js